export function portionToValue(portion: string) {
  if (!portion) return 0;

  const splitted = portion.split(" ");
  if (splitted.length != 2) return NaN;
  return parseInt(splitted.at(0));
}
